// eslint-disable-next-line import/no-unresolved
import { produce } from 'immer';

export default {
  0: state => {
    const newState = produce(state, draft => {
      draft.user = {};

      if (state.userId) {
        draft.user.userId = state.userId;
        delete draft.userId;
      }

      if (state.userProgress) {
        draft.user.userProgress = state.userProgress;
        delete draft.userProgress;
      }

      draft.enrollment = {};
      if (state.enrollmentCompleted) {
        draft.enrollment.status = state.enrollmentCompleted;
        delete draft.enrollmentCompleted;
      }
    });

    return newState;
  },
};
